import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

const windowState = window.state;

const state = {
  customers: {},
  instance: null,
  category_id: null,
  me: null,
  meCalled: false,
  meLoaded: false,
  category: null,
  extensions: [],
  activeExtension: null,
  extensionsLoaded: false,
  extensionsCalled: false,
  ...windowState,
};

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
});
